import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section, PrimaryButton, SecondaryButton } from "@/components/ui-helpers";
import { api } from "@/lib/api";

const tierLabel = (tier) => (tier === "detail" ? "Detailing" : tier === "deep" ? "Deep Clean" : "Cleaning");

export default function Services() {
  const [services, setServices] = useState([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- one-shot load on mount
  useEffect(() => { api.get("/services").then(({ data }) => setServices(data)).catch(() => {}); }, []);
  return (
    <>
      <SEO title="Cleaning & Detailing Services" description="Post-construction, move-in/out, general and deep cleaning, plus premium property detailing across Israel." />
      <PageHero kicker="Our Services" title="From construction site to move-in ready" subtitle="Professional cleaning and meticulous detailing, tailored to your property's condition and the finish you want.">
        <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
        <SecondaryButton to="/detailing-menu">Explore the Detail Menu</SecondaryButton>
      </PageHero>

      <Section>
        <div className="grid gap-5 md:grid-cols-2">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 2) * 0.08}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="svc-tile group flex min-h-[24rem] flex-col justify-end p-7"
              >
                <img src={s.hero_image} alt={s.name} loading="lazy" decoding="async" className="svc-media" />
                <div className="svc-overlay" />
                <span className="svc-hairline" aria-hidden="true" />
                <span className="absolute right-7 top-6 editorial-index select-none" aria-hidden="true">{String(i + 1).padStart(2, "0")}</span>
                <div className="relative z-10">
                  <p className="text-[11px] uppercase tracking-[0.18em] text-gold-soft">{tierLabel(s.tier)}</p>
                  <h3 className="mt-2 display-3 text-white">{s.name}</h3>
                  <p className="mt-3 text-sm text-secondary u-body max-w-[42ch]">{s.short}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-white">Explore service <ArrowRight className="svc-cta-arrow h-4 w-4 text-gold-soft" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
}
